export default "__VITE_ASSET__Ci2gOZn___"